/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { Modal, Typography, Divider, List, Tag, Spin } from "antd";
import moment from "moment";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE } from "../../constants/messages";
import { BOOKING_LOG } from "../../constants/api";

const { Text } = Typography;

const actionColors = {
  checkin: "green",
  checkout: "red",
  booking_accepted: "blue",
  booking_rejected: "volcano",
  room_assigned: "purple",
  room_unassigned: "orange",
  advance_payment: "gold",
  booking_edited: "cyan",
  regenrated_invoice_or_grc: "geekblue",
};

const BookingLogsModal = ({ visible, onClose, booking_id }) => {
  const [bookingLogs, setBookingLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    if (visible) {
      getBookingLogs();
    }
  }, [visible]);

  const getBookingLogs = () => {
    setLoading(true);
    const body = { id: booking_id };

    const successFn = (data) => {
      setLoading(false);
      if (data.status === true && data.data) {
        setBookingLogs(data.data);
      } else {
        onClose();
        displayMessage(ERROR_MSG_TYPE, data.message || "No logs found");
      }
    };

    const errorFn = () => {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to get logs");
    };

    postAPI(BOOKING_LOG, body, successFn, errorFn);
  };

  return (
    <Modal
      title="Booking Logs"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={640}
      zIndex={1000000}
    >
      <Divider />

      {loading ? (
        <div style={{ textAlign: "center", padding: "2rem 0" }}>
          <Spin size="large" />
        </div>
      ) : (
        <List
          itemLayout="vertical"
          dataSource={bookingLogs}
          renderItem={(log) => (
            <List.Item key={log.id}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Tag color={actionColors[log.action] || "default"}>
                  {log.action.toUpperCase()}
                </Tag>
                <Text type="secondary">
                  {moment(log.created_at).format("DD MMM YYYY, hh:mm A")}
                </Text>
              </div>
              <div style={{ marginTop: 8 }}>
                <div>
                  {log.description.split('\n').map((line, index) => (
                    <Text key={index} style={{ display: "block" }}>
                      {line}
                    </Text>
                  ))}
                </div>
              </div>
              <div style={{ marginTop: 4 }}>
                <Text type="secondary">By: {log?.user?.name || "System"}</Text>
              </div>
            </List.Item>
          )}
        />
      )}

      <Divider />
    </Modal>
  );
};

export default BookingLogsModal;
